const MONTHS = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];

export const fmtNum = (n, d = 0) =>
  n == null || Number.isNaN(n) ? "—" : Number(n).toLocaleString("en-IN", { maximumFractionDigits: d });

export const fmtINR = (n) =>
  n == null ? "—" : `₹${Number(n).toLocaleString("en-IN", { maximumFractionDigits: 0 })}`;

const pad = (n) => String(n).padStart(2, "0");

export const todayStr = () => {
  const d = new Date();
  return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}`;
};

export const monthStr = () => todayStr().slice(0, 7);

export const monthLabel = (m) => {
  const [y, mo] = m.split("-");
  return `${MONTHS[Number(mo) - 1]} '${y.slice(2)}`;
};

export const dateLabel = (d) => {
  if (!d) return "—";
  const [y, m, day] = d.split("-");
  return `${day} ${MONTHS[Number(m) - 1]} ${y}`;
};

const ONES = ["", "One", "Two", "Three", "Four", "Five", "Six", "Seven", "Eight", "Nine", "Ten", "Eleven", "Twelve",
  "Thirteen", "Fourteen", "Fifteen", "Sixteen", "Seventeen", "Eighteen", "Nineteen"];
const TENS = ["", "", "Twenty", "Thirty", "Forty", "Fifty", "Sixty", "Seventy", "Eighty", "Ninety"];

const below1000 = (n) => {
  const h = Math.floor(n / 100);
  const r = n % 100;
  const rest = r < 20 ? ONES[r] : `${TENS[Math.floor(r / 10)]} ${ONES[r % 10]}`.trim();
  return [h ? `${ONES[h]} Hundred` : "", rest].filter(Boolean).join(" ");
};

export const amountInWords = (amount) => {
  let n = Math.round(amount);
  if (!n) return "Rupees Zero Only";
  const parts = [];
  [[10000000, "Crore"], [100000, "Lakh"], [1000, "Thousand"]].forEach(([v, label]) => {
    const q = Math.floor(n / v);
    if (q) { parts.push(`${q >= 1000 ? amountInWords(q).replace(/^Rupees | Only$/g, "") : below1000(q)} ${label}`); n %= v; }
  });
  if (n) parts.push(below1000(n));
  return `Rupees ${parts.join(" ")} Only`;
};
